import React from 'react';
import { observer } from 'mobx-react';
import ModeExcel from '../../stores/card/ModeExcel';

export interface ExcelTableColgroupTrProps {
    excel?: ModeExcel;
    isFixFieldDiv?:boolean;
}

@observer
export default class ExcelTableColgroupTr extends React.Component<ExcelTableColgroupTrProps, any> {
    render() {
        const { excel,isFixFieldDiv } = this.props;
        return (
            <tr className="detailControlWidth">
                {
                    excel&&excel.cols.slice().map(({ size,hide },index) => {
                        const fixFieldIndex = excel.fixFieldIndex || 0;
                        if(isFixFieldDiv && index > fixFieldIndex){
                            return;
                        }
                        return (
                            <td    style={{display:hide && hide ==="y" ? "none":"",width:size }} />
                        )
                    })
                }
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/ColgroupTr.tsx